import React from 'react';
import { observer } from 'src/utils/mobx-react';
import Loading from 'src/components/Loading/Loading';
import { CustomDropdown, FilterOptionType } from 'src/components/RealityCheckForm/CustomDropdown';
import { useAppStateContext } from 'src/AppState/AppState';
import { DateTime } from 'src_common/utils/time/time';
import { ButtonTag, ButtonWrapper } from './DepositRestrictionTab.style';
import { DEPOSIT_RESTRICTION_OPTIONS_ARRAY, DepositRestrictionState } from './DepositRestrictionTab.state';
import {
    ErrorMessage,
    SubPageWrapper,
} from 'src/components/CustomersBar/CustomerTab/ResponsibleGamblingTab/ResponsibleGamblingTabs.style';

interface DepositRestrictionType {
    customerId: number;
}

export const DepositRestriction = observer('DepositRestriction', ({ customerId }: DepositRestrictionType) => {
    const { models, trpcClient } = useAppStateContext();
    const [state] = React.useState(() => new DepositRestrictionState(trpcClient, customerId, models));

    return (
        <SubPageWrapper>
            <h2>Deposit Restriction:</h2>
            <table>
                <tbody>
                    <tr>
                        <th>Reason:</th>
                        <td data-test='deposit-restriction-reason'>{state.getSourceReason}</td>
                    </tr>
                    {state.getSourceDescription !== null && state.getSourceDescription !== '' && (
                        <tr>
                            <th>Description:</th>
                            <td data-test='deposit-restriction-description'>{state.getSourceDescription}</td>
                        </tr>
                    )}
                    <tr>
                        <th>Triggered:</th>
                        <td data-test='deposit-restriction-triggered'>
                            {state.getDepositRestriction === null
                                ? 'none'
                                : DateTime.from(state.getDepositRestriction.updatedAt)?.format('DD/MM/YYYY HH:mm:ss')}
                        </td>
                    </tr>
                    <tr>
                        <th>Expires:</th>
                        <td data-test='deposit-restriction-expires'>{state.getEndDate}</td>
                    </tr>
                </tbody>
            </table>
            <div>
                <CustomDropdown
                    optionsList={(): Array<FilterOptionType<number | null>> => DEPOSIT_RESTRICTION_OPTIONS_ARRAY}
                    selectedValue={(): number | null => state.selectedPeriod}
                    onChangeCallback={state.onUpdatePeriod}
                    placeholder='Restriction period'
                    labelHeader='Restriction period'
                    dataTest='restriction-period-dropdown'
                />

                {state.isError ? <ErrorMessage>Something went wrong</ErrorMessage> : null}

                <ButtonWrapper>
                    <ButtonTag
                        disabled={false}
                        onClick={state.onSetDepositRestriction}
                        className='btn'
                        type='submit'
                        data-test='set-deposit-restriction-button'
                    >
                        Set deposit restriction
                    </ButtonTag>
                    <ButtonTag
                        disabled={state.getDepositRestriction === null}
                        onClick={state.onRemoveDepositRestriction}
                        className='btn'
                        type='submit'
                        isDeleteButton={true}
                        data-test='remove-deposit-restriction-button'
                    >
                        Remove deposit restriction
                    </ButtonTag>
                </ButtonWrapper>
            </div>
            <Loading active={state.isLoading} />
        </SubPageWrapper>
    );
});
